<template>
    <div class="completed-percentage-bar" :style="barStyle" @click="toggleTooltip">
      <template v-if="showTooltip">
        <div class="custom-tooltip">
          <div class="custom-tooltip-row">
            <span class="custom-tooltip-row-center-span fw-bold">
              {{ shiftDescrip ?? 'Turno desconocido' }}
            </span>
          </div>
          <div class="custom-tooltip-row">
            <span class="custom-tooltip-row-left-span fw-bold">
              Inicio: 
            </span>
            <span class="custom-tooltip-row-right-span">
              {{ percentageBarStartDate ?? 'Fecha no disponible' }}
            </span>
          </div>
            <div class="custom-tooltip-row">
              <span class="custom-tooltip-row-left-span fw-bold">
                Fin: 
              </span>
              <span class="custom-tooltip-row-right-span">
                {{ percentageBarEndDate ?? 'Fecha no disponible' }}
              </span>
            </div>
            <div class="custom-tooltip-row">
              <span class="custom-tooltip-row-left-span fw-bold">
              - Progreso -
              </span>
            </div>
            <div class="custom-tooltip-row">
              <span class="custom-tooltip-row-left-span fw-bold">
                Cajas: 
              </span>
              <span class="custom-tooltip-row-right-span">
                {{ producedQuantity ?? '0' }}/{{ barPercentageMax ?? '0' }} ({{ boxesCompletionPercentage ?? '0' }}%)
              </span>
            </div>
            <div class="custom-tooltip-row">
              <span class="custom-tooltip-row-left-span fw-bold">
                Bolsas: 
              </span>
              <span class="custom-tooltip-row-right-span">
                {{ bagsProduced ?? '0' }}/{{ bagsToProduce ?? '0' }} ({{ bagsCompletionPercentage ?? '0' }}%)
              </span>
            </div>
        </div>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    name: "PercentageBar",
    props: {
      producedQuantity: Number,
      barPercentageMax: Number,
      percentageBarStartDate: String,
      percentageBarEndDate: String,
      shiftDescrip: String,
      bagsProduced: Number,
      bagsToProduce: Number,
      barStyle: String,
    },
    data() {
      return {
        showTooltip: false,
      };
    },
    computed: {
      boxesCompletionPercentage() {
        return Math.round((this.producedQuantity / this.barPercentageMax) * 100);
      },
      bagsCompletionPercentage() {
        return Math.round((this.bagsProduced / this.bagsToProduce) * 100);
      },
    },
    methods: {
      toggleTooltip() {
        this.showTooltip = !this.showTooltip;
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
    .completed-percentage-bar {
        position: relative;
        cursor: pointer;
    }
    
    /* Tooltip estilos */
    .custom-tooltip {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-100%);
      background-color: rgba(0, 0, 0, 0.85);
      color: #fff;
      padding: 8px 12px;
      border-radius: 6px;
      white-space: nowrap;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
      z-index: 10;
      font-size: 16px;
      line-height: 1.4;
      font-weight: 500;
      .custom-tooltip-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
        &:last-child {
          margin-bottom: 0;
        }
        &>span {
          width: 100%;
        }
        .custom-tooltip-row-left-span {
          text-align: left;
        }
        .custom-tooltip-row-right-span {
          margin-left: 8px;
          text-align: right;
        }
        .custom-tooltip-row-center-span {
          text-align: center;
        }
      }
    }

  </style>
  